import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar'; 
export default function NavBar() {
  return (
    <div>
      <Navbar expand="lg" >
      <Container>
        <Navbar.Brand href="#"><h3>Portfolio</h3></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav mx-2"> 
          <Nav className="me-auto">
            <Nav.Link href="#about"><h5><b>About</b></h5></Nav.Link>
            <Nav.Link href="#work"><h5><b>Work</b></h5></Nav.Link>
            <Nav.Link href="#Contact"><h5><b>Contact</b></h5></Nav.Link> 
          </Nav> 
        </Navbar.Collapse>
      </Container>
    </Navbar>
    </div>
  )
}
